module.exports = __webpack_public_path__ + "img/potrait.f7031054.jpg";